import React from 'react'
import CoachAnalytics from './coach-analytics'

const CoachAnalyticsPage = () => {
  return <CoachAnalytics />
}

export default CoachAnalyticsPage
